import React, { useContext, useEffect, useState } from "react";
import { ColorContext } from "../../AppContext";
import { hexToRGBAfterOpactiy } from "../../utils/HexToRGB";
import { MdNavigateNext, MdOutlineFolder } from "react-icons/md";
import "./Tags.css";
import { FiTag, FiPlus } from "react-icons/fi";
import { Route, Switch, Link } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@material-ui/core";
import FolderLink from "./icons/FolderLink";
import FolderAdd from "./icons/FolderAdd";
import TagAdd from "./icons/TagAdd";
import TagLink from "./icons/TagLink";
import LinkTagFolderPopup from "./popups/LinkTagFolderPopup";
import EditTagFolder from "./popups/EditFolder";
import { callApi } from "../../api/useApi";
import { Menu as CMenu, Item, useContextMenu } from "react-contexify";
import "react-contexify/dist/ReactContexify.css";
import { toInteger } from "lodash";

const Tags = ({ match, location, history }) => {
  const isTrending = location?.pathname?.includes("trending");
  const parents = location?.state?.parents;
  const parent_id = match.params.id;
  const [color] = useContext(ColorContext);
  const [popupType, setPopupType] = useState();
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [popupData, setPopupData] = useState({});
  const { show } = useContextMenu({
    id: "context-menu",
  });

  function handleItemClick({ event, props, triggerEvent, data }) {
    switch (data) {
      case "edit":
        setPopupData(props);
        setPopupType(props.type ? "Edit Folder" : "Edit Tag");
        break;
      case "unlink":
        const confirmation = window.confirm("Are You Sure you want to unlink?");
        if (confirmation) {
          callApi("unlinkChild", {
            parentId: parseInt(parent_id),
            itemId: props.id,
          }).then((data) => {
            if (props.type) {
              setCategories((categories) =>
                categories.filter((category) => category.id !== props.id)
              );
            } else {
              setTags((tags) => tags.filter((tag) => tag.id !== props.id));
            }
          });
        }
        break;
      case "delete":
        const confirmatio = window.confirm("Are You Sure You want to Delete?");
        if (confirmatio) {
          callApi("deleteItem", {
            id: props.id,
          }).then((data) => {
            if (props.type) {
              setCategories((categories) =>
                categories.filter((category) => category.id !== props.id)
              );
            } else {
              setTags((tags) => tags.filter((tag) => tag.id !== props.id));
            }
          });
        }
        break;
    }
  }
  const initData = async () => {
    const endpoint = isTrending
      ? "listTrendingFolders"
      : !parent_id
      ? "listRootFolders"
      : "listFolderChildren";
    callApi(endpoint, parent_id ? { id: parseInt(parent_id) } : {}).then((res) => {
      let _categories = [],
        _tags = [];
      if (res)
        res.records.map((record) => {
          const data = {
            id: record.get("children").identity,
            ...record.get("children").properties,
          };
          if (record.get("children").labels[0] === "ETagsFolder") {
            _categories = [..._categories, data];
          } else {
            _tags = [..._tags, data];
          }
        });
      setCategories(_categories);
      setTags(_tags);
    });
  };

  function sortData(oldData = [], newData = [], type) {
    const changedData = oldData.filter(
      (val, index) => val.id !== newData[index].id
    );
    changedData.forEach((val) => {
      if (!parent_id) {
        callApi("reorderRoot", {
          id: val.id,
          order: newData.map((e) => e.id).indexOf(val.id) + 1,
        });
      } else {
        callApi("reorderChild", {
          parentId: parseInt(parent_id),
          itemId: val.id,
          order: newData.map((e) => e.id).indexOf(val.id) + 1,
        });
      }
    });

    return newData;
  }

  function createFolder(data) {
    setPopupType(null);

    callApi(parent_id ? "createChildFolder" : "createRootFolder", {
      id: parent_id ? parseInt(parent_id) : undefined,
      folder: {
        type: isTrending ? "trending" : parent_id ? "regular" : "root",
        ...data,
      },
      order: categories.length + 1,
    }).then((res) => {
      const folder = res.records[0].get("folder");
      setCategories((categories) => [
        ...categories,
        { ...folder.properties, id: folder.identity },
      ]);
      if (isTrending) {
        data.keywords
          .map((e) => toInteger(e))
          .forEach((val) => {
            callApi("linkLetterToFolder", {
              id: folder.identity,
              letterId: val,
            }).then((res) => {
              console.log(res);
            });
          });
      }
    });
  }
  function createTag(data) {
    setPopupType(null);
    callApi("createTag", {
      id: parseInt(parent_id),
      tag: data,
      order: tags.length + 1,
    }).then((res) => {
      const tag = res.records[0].get("tag");
      setTags((tags) => [
        ...tags,
        { ...tag.properties, id: tag.identity },
      ]);
    });
  }
  function updateFolder(id, data) {
    setPopupType(null);
    callApi("updateItem", {
      id: id,
      data: data,
    }).then((res) => {
      const category = res.records[0].get("item");
      setCategories((categories) => {
        if (data.type == "trending") {
          data.keywords
            .filter(
              (x) => !categories.find((e) => e.id == id).keywords.includes(x)
            )
            .forEach((val) => {
              callApi("linkLetterToFolder", {
                id: category.identity,
                letterId: toInteger(val),
              });
            });
          categories
            .find((e) => e.id == id)
            .keywords.filter((x) => !data.keywords.includes(x))
            .forEach((val) => {
              callApi("unlinkLetterFromFolder", {
                id: category.identity,
                letterId: toInteger(val),
              });
            });
        }
        const _categories = categories.map((e) => {
          if (e.id == id) {
            e = category.properties;
          }
          return e;
        });
        return _categories;
      });
    });
  }
  function updateTag(id, data) {
    setPopupType(null);
    callApi("updateItem", {
      id: id,
      data: data,
    }).then((res) => {
      const tag = res.records[0].get("item");
      setTags((tags) => {
        const _tags = tags.map((e) => {
          if (e.id == id) {
            e = tag.properties;
          }
          return e;
        });
        return _tags;
      });
    });
  }

  useEffect(() => {
    initData();
  }, []);

  return (
    <>
      {match.isExact && (
        <>
          <div
            id="header"
            style={{
              backgroundColor: hexToRGBAfterOpactiy(color, 0.05),
            }}
          >
            <div
              className="header-text"
              onClick={() => parents && history.go(-parents.length)}
            >
              Topics
            </div>

            {parents &&
              parents.map((parent, i) => (
                <>
                  <MdNavigateNext color="#707070" size={24} />
                  <div
                    className="header-text"
                    onClick={() =>
                      i + 1 != parents.length &&
                      history.go(i - parents.length + 1)
                    }
                  >
                    {parent.name}
                  </div>
                </>
              ))}
          </div>
          <ReactSortable
            list={categories}
            setList={(data) =>
              setCategories(sortData(categories, data, "folder"))
            }
            animation={200}
            ghostClass="ghost"
            delay={400}
          >
            {categories.map((value, index) =>
              value.type == "trending" ? (
                <div
                  key={value.id}
                  className="tile"
                  onContextMenu={(e) =>
                    show(e, {
                      props: {
                        ...value,
                      },
                    })
                  }
                >
                  <MdOutlineFolder color="#707071" size={24} />
                  <div className="tile-text">{value.name}</div>
                </div>
              ) : (
                <Link
                  key={value.id}
                  to={{
                    pathname: `${match.url}/${value.id}`,
                    state: {
                      parents: parents ? [...parents, value] : [value],
                    },
                  }}
                  className="tile"
                  onContextMenu={(e) =>
                    show(e, {
                      props: {
                        ...value,
                      },
                    })
                  }
                >
                  <MdOutlineFolder color="#707071" size={24} />
                  <div className="tile-text">{value.name}</div>
                </Link>
              )
            )}
          </ReactSortable>
          <ReactSortable
            list={tags}
            setList={(data) => setTags(sortData(tags, data, "tag"))}
            animation={200}
            ghostClass="ghost"
            delay={400}
          >
            {tags.map((value, index) => (
              <div
                className="tile"
                key={index}
                onContextMenu={(e) =>
                  show(e, {
                    props: {
                      ...value,
                    },
                  })
                }
              >
                <FiTag color="#707071" size={24} />
                <div className="tile-text">{value.name}</div>
              </div>
            ))}
          </ReactSortable>
        </>
      )}
      {popupType === "Add Folder" && (
        <EditTagFolder
          isNew={true}
          isRoot={!parent_id}
          isTrending={isTrending}
          onCancel={() => setPopupType(null)}
          onSave={(data) => createFolder(data)}
        />
      )}
      {popupType === "Add Tag" && (
        <EditTagFolder
          isNew={true}
          isTag={true}
          onCancel={() => setPopupType(null)}
          onSave={(data) => createTag(data)}
        />
      )}
      {popupType === "Edit Folder" && (
        <EditTagFolder
          isTrending={popupData.type === "trending"}
          isRoot={!parent_id}
          data={popupData}
          onCancel={() => setPopupType(null)}
          onSave={(data) => updateFolder(popupData.id, data)}
        />
      )}
      {popupType === "Edit Tag" && (
        <EditTagFolder
          isTag={true}
          data={popupData}
          onCancel={() => setPopupType(null)}
          onSave={(data) => updateTag(popupData.id, data)}
        />
      )}
      {popupType === "Link Folder" && (
        <LinkTagFolderPopup
          onCancel={() => setPopupType(null)}
          onSave={(selected) => {
            setPopupType(null);
            selected.forEach((external_id, index) => {
              callApi("linkChild", {
                parentId: parseInt(parent_id),
                externalId: external_id,
                order: categories.length + tags.length + index + 1,
              }).then((res) => {
                initData();
              });
            });
          }}
        />
      )}
      {popupType === "Link Tag" && (
        <LinkTagFolderPopup
          isTag={true}
          onCancel={() => setPopupType(null)}
          onSave={(selected) => {
            setPopupType(null);
            selected.forEach((external_id, index) => {
              callApi("linkChild", {
                parentId: parseInt(parent_id),
                externalId: external_id,
                order: categories.length + tags.length + index + 1,
              }).then((res) => {
                initData();
              });
            });
          }}
        />
      )}
      <AddTag onClick={setPopupType} showTagOptions={parent_id != null} />
      <CMenu id={"context-menu"}>
        <Item onClick={handleItemClick} data={"edit"}>
          Edit
        </Item>
        {!isTrending && (
          <Item onClick={handleItemClick} data={"unlink"}>
            Unlink
          </Item>
        )}
        <Item onClick={handleItemClick} data={"delete"}>
          Delete
        </Item>
      </CMenu>
      <Switch>
        <Route path={`${match.path}/:id`} component={Tags} />
      </Switch>
    </>
  );
};
export default Tags;

function AddTag({ onClick, showTagOptions = true }) {
  const [color] = useContext(ColorContext);

  const [anchorEl, open] = React.useState(null);
  const handleClick = (event) => {
    open(event.currentTarget);
  };

  const handleClose = (type) => {
    if (type) {
      onClick(type);
    }
    open(null);
  };
  return (
    <div>
      <div
        className="add_letter"
        style={{ backgroundColor: color }}
        onClick={handleClick}
      >
        <FiPlus className="add_icon" />
      </div>
      <Menu
        id="Menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleClose("Add Folder")}>
          <ListItemIcon style={{ minWidth: "0", paddingRight: "15px" }}>
            <FolderAdd />
          </ListItemIcon>
          <span className="options-title">Add Folder</span>
        </MenuItem>
        {showTagOptions && (
          <MenuItem onClick={() => handleClose("Link Folder")}>
            <ListItemIcon style={{ minWidth: "0", paddingRight: "15px" }}>
              <FolderLink />
            </ListItemIcon>
            <span className="options-title">Link Folder</span>
          </MenuItem>
        )}
        {showTagOptions && (
          <MenuItem onClick={() => handleClose("Add Tag")}>
            <ListItemIcon style={{ minWidth: "0", paddingRight: "15px" }}>
              <TagAdd />
            </ListItemIcon>
            <span className="options-title">Add Tag</span>
          </MenuItem>
        )}
        {showTagOptions && (
          <MenuItem onClick={() => handleClose("Link Tag")}>
            <ListItemIcon style={{ minWidth: "0", paddingRight: "15px" }}>
              <TagLink />
            </ListItemIcon>
            <span className="options-title">Link Tag</span>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}